export default "__VITE_ASSET__BpG7YWK3__"